export default function DragHandleIcon() {
  return (
    <svg
      aria-hidden="true"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.33341 4.33333C6.25389 4.33333 7.00008 3.58714 7.00008 2.66667C7.00008 1.74619 6.25389 1 5.33341 1C4.41294 1 3.66675 1.74619 3.66675 2.66667C3.66675 3.58714 4.41294 4.33333 5.33341 4.33333Z"
        fill="#5C5C5C"
      />
      <path
        d="M10.3334 4.33333C11.2539 4.33333 12.0001 3.58714 12.0001 2.66667C12.0001 1.74619 11.2539 1 10.3334 1C9.41295 1 8.66675 1.74619 8.66675 2.66667C8.66675 3.58714 9.41295 4.33333 10.3334 4.33333Z"
        fill="#5C5C5C"
      />
      <path
        d="M7.00008 7.99967C7.00008 8.92014 6.25389 9.66634 5.33341 9.66634C4.41294 9.66634 3.66675 8.92014 3.66675 7.99967C3.66675 7.07921 4.41294 6.33301 5.33341 6.33301C6.25389 6.33301 7.00008 7.07921 7.00008 7.99967Z"
        fill="#5C5C5C"
      />
      <path
        d="M10.3334 9.66634C11.2539 9.66634 12.0001 8.92014 12.0001 7.99967C12.0001 7.07921 11.2539 6.33301 10.3334 6.33301C9.41295 6.33301 8.66675 7.07921 8.66675 7.99967C8.66675 8.92014 9.41295 9.66634 10.3334 9.66634Z"
        fill="#5C5C5C"
      />
      <path
        d="M7.00008 13.3337C7.00008 14.2541 6.25389 15.0003 5.33341 15.0003C4.41294 15.0003 3.66675 14.2541 3.66675 13.3337C3.66675 12.4132 4.41294 11.667 5.33341 11.667C6.25389 11.667 7.00008 12.4132 7.00008 13.3337Z"
        fill="#5C5C5C"
      />
      <path
        d="M10.3334 15.0003C11.2539 15.0003 12.0001 14.2541 12.0001 13.3337C12.0001 12.4132 11.2539 11.667 10.3334 11.667C9.41295 11.667 8.66675 12.4132 8.66675 13.3337C8.66675 14.2541 9.41295 15.0003 10.3334 15.0003Z"
        fill="#5C5C5C"
      />
    </svg>
  );
}
